// Global Instructions Rule Applied!
// Grid row shape of POST /capital-calls/filter (view__capital_calls).
import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CapitalCallRecordSchema = z
  .object({
    capital_calls__id: z.string(),
    funds__id: z.string(),
    funds__name: z.string().nullish(),
    capital_calls__name: z.string().nullish(),
    capital_calls__call_date: z.string().nullish(),
    capital_calls__call_date_fmt: z.string().nullish(),
    capital_calls__due_date: z.string().nullish(),
    capital_calls__due_date_fmt: z.string().nullish(),
    cfg_capital_call_statuses__id: z.number().nullish(),
    cfg_capital_call_statuses__label: z.string().nullish(),
    currencies__id: z.string().nullish(),
    currencies__code: z.string().nullish(),
    capital_calls__total_amount: z.number().nullish(),
    capital_calls__total_amount_fmt: z.string().nullish(),
    capital_calls__commitment_count: z.number().nullish(),
    fund_transactions__id: z.string().nullish(),
    cfg_transaction_statuses__label: z.string().nullish()
  })
  .strict()

export const CapitalCallRecordFields = makeFieldKeys(CapitalCallRecordSchema)

export type CapitalCallRecord = z.infer<typeof CapitalCallRecordSchema>

export function validateCapitalCallRecord(data: unknown, isArray: true): CapitalCallRecord[]
export function validateCapitalCallRecord(data: unknown, isArray?: false): CapitalCallRecord
export function validateCapitalCallRecord(data: unknown, isArray?: boolean): CapitalCallRecord | CapitalCallRecord[]
export function validateCapitalCallRecord(data: unknown, isArray = false): CapitalCallRecord | CapitalCallRecord[] {
  try {
    return validateWithZodSchema(CapitalCallRecordSchema, data, 'capital call record', { isArray })
  } catch (error) {
    throw new Error(`Capital call record validation failed: ${error}`)
  }
}
